// Libs
import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
// Components, Layouts, Pages
import { Loading, UnderDevelopment } from '~/components/common';
import FormCreateTask from '~/components/module/job/formCreateTask/FormCreateTask';
// Others
import { useAppDispatch } from '~/utils/redux/hooks';
import { removeEmptyObjects } from '~/utils/helper/common';
import { IFormJobTask, IQueryCreateTaskJob, IQueryEditTaskJob } from '~/utils/interface/job';
import { createTaskInJob, editTaskInJob } from '~/thunks/task/taskThunk';
import { taskActions } from '~/thunks/task/taskSlice';
import { jobActions } from '~/thunks/job/jobSlice';
import { LocationEnum } from '~/utils/enum/common';
// Styles, images, icons

type Props = {
  jobId?: string;
  taskId?: string;
  customerId?: string;
  onClose: () => void;
  onCallBack?: (data?: IFormJobTask) => void;
};

const ModalFormTaskJob = (props: Props) => {
  //#region Destructuring Props
  const { jobId, taskId, onClose, onCallBack, customerId } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const dispatch = useAppDispatch();
  const { t } = useTranslation(['admin/job', 'common/base']);
  const { hash } = useLocation();
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isShowUnderDevelopment, setIsShowUnderDevelopment] = useState<boolean>(false);
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const handleCancelModalFormTask = () => {
    onClose();
  };

  const handleEditTask = (data: IFormJobTask) => {
    if (!taskId) return;
    setIsLoading(true);

    const { status, ...resData } = data;

    const paramEdit: IQueryEditTaskJob = {
      taskId,
      body: resData,
    };

    dispatch(editTaskInJob(paramEdit))
      .unwrap()
      .then((res) => {
        onCallBack && onCallBack(data);
        dispatch(taskActions.setRefreshTaskList(true));
        handleCancelModalFormTask();
      })
      .catch((error) => {})
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleCreateTask = (data: IFormJobTask) => {
    if (!jobId) return;
    const { status, ...resData } = data;

    const body: IFormJobTask = removeEmptyObjects(resData) as IFormJobTask;

    const paramCreate: IQueryCreateTaskJob = {
      jobId,
      body,
    };

    setIsLoading(true);

    dispatch(createTaskInJob(paramCreate))
      .unwrap()
      .then((_res) => {
        onCallBack && onCallBack(body);
        hash === LocationEnum.SCHEDULE && dispatch(jobActions.setIsRefreshScheduleData(true));
        hash === LocationEnum.TASK && dispatch(taskActions.setRefreshTaskList(true));
        handleCancelModalFormTask();
      })
      .catch((_error) => {})
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleSubmitForm = (data: IFormJobTask) => {
    if (onCallBack && !jobId) {
      onCallBack(data);
      return;
    }

    const { assignee, ...restData } = data;

    if (taskId) {
      handleEditTask(restData);
    } else {
      handleCreateTask(restData);
    }
  };

  const handleCloseUnderDevelopment = () => {
    setIsShowUnderDevelopment(false);
  };
  //#endregion Handle Function

  return (
    <Dialog id='modalFormTask' open={true} fullWidth maxWidth={'md'} onClose={handleCancelModalFormTask}>
      <DialogTitle>{taskId ? t('form_task_title_edit') : t('form_task_title')}</DialogTitle>
      <DialogContent dividers={true}>
        <FormCreateTask
          onClose={handleCancelModalFormTask}
          onSave={handleSubmitForm}
          customerId={customerId}
          taskId={taskId}
        />
      </DialogContent>

      {isLoading && <Loading />}

      <UnderDevelopment isOpen={isShowUnderDevelopment} onClose={handleCloseUnderDevelopment} />
    </Dialog>
  );
};

export default ModalFormTaskJob;
